import logger from '../../utils/logger';
import React, { useState, useContext } from 'react';
import { GlobalStateContext } from '../../utils/GlobalStateContext';
import { getUserId } from '../../utils/utils';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../style/ImagingModals.css';
import '../../style/OrderDisplay.css';

const labTests = [
  { code: "82024", name: "Adrenocorticotropic hormone (ACTH) level", type: "Blood" },
  { code: "80105", name: "Alpha-fetoprotein (AFP) level, serum", type: "Blood" },
  { code: "80048", name: "Basic Metabolic Panel", type: "Blood" },
  { code: "85004", name: "Blood count; automated differential WBC count", type: "Blood" },
  { code: "85027", name: "Blood count; complete (CBC), automated", type: "Blood" },
  { code: "85025", name: "Blood count; complete (CBC) with automated differential", type: "Blood" },
  { code: "85014", name: "Blood count; hematocrit (Hct)", type: "Blood" },
  { code: "85018", name: "Blood count; hemoglobin (Hgb)", type: "Blood" },
  { code: "85048", name: "Blood count; leukocyte (WBC), automated", type: "Blood" },
  { code: "85013", name: "Blood count; spun microhematocrit", type: "Blood" },
  { code: "85049", name: "Blood count; platelet, automated", type: "Blood" },
  { code: "85041", name: "Blood count; red blood cell (RBC), automated", type: "Blood" },
  { code: "87040", name: "Blood Culture", type: "Blood" },
  { code: "85060", name: "Blood smear, peripheral, interpretation by physician", type: "Blood" },
  { code: "89051", name: "Cell count, miscellaneous body fluids with differential", type: "Blood" },
  { code: "80053", name: "Comprehensive Metabolic Panel", type: "Blood" },
  { code: "82533", name: "Cortisol (hormone) measurement, total", type: "Blood" },
  { code: "82553", name: "Creatine kinase (cardiac enzyme) level, MB fraction only", type: "Blood" },
  { code: "82607", name: "Cyanocobalamin (vitamin B-12) level", type: "Blood" },
  { code: "82627", name: "Dehydroepiandrosterone (DHEA-S) hormone level", type: "Blood" },
  { code: "93000", name: "Electrocardiogram", type: "EKG" },
  { code: "88312", name: "Fecal Occult Blood Test (Guaiac-based)", type: "Stool" },
  { code: "82728", name: "Ferritin (blood protein) level", type: "Blood" },
  { code: "82746", name: "Folic acid level, serum", type: "Blood" },
  { code: "82747", name: "Folic acid level, RBC", type: "Blood" },
  { code: "83001", name: "Gonadotropin, follicle stimulating (reproductive hormone) level", type: "Blood" },
  { code: "84702", name: "Gonadotropin, chorionic (reproductive hormone) level", type: "Blood" },
  { code: "83002", name: "Gonadotropin, luteinizing (reproductive hormone) level", type: "Blood" },
  { code: "82150", name: "General Chemistry 13", type: "Blood" },
  { code: "82947", name: "Glucose", type: "Finger Stick" },
  { code: "80076", name: "Liver Panel Plus", type: "Blood" },
  { code: "83090", name: "Homocysteine (amino acid) level", type: "Blood" },
  { code: "86301", name: "CA 19-9 tumor antigen", type: "Blood" },
  { code: "86304", name: "CA 125 tumor antigen", type: "Blood" },
  { code: "82785", name: "IgE (immune system protein) level", type: "Blood" },
  { code: "83525", name: "Insulin measurement, total", type: "Blood" },
  { code: "86800", name: "Hemoglobin A1C level", type: "Blood" },
  { code: "83003", name: "Human growth hormone level", type: "Blood" },
  { code: "83874", name: "Myoglobin (muscle protein) level", type: "Blood" },
  { code: "", name: "Metlyte 8 Panel", type: "Blood" },
  { code: "83880", name: "Natriuretic peptide (heart and blood vessel protein) level", type: "Blood" },
  { code: "86689", name: "Monospot Test", type: "Throat" },
  { code: "83970", name: "Parathormone (parathyroid hormone) level", type: "Blood" },
  { code: "84066", name: "Phosphatase, prostatic (prostate enzyme) level", type: "Blood" },
  { code: "84144", name: "Progesterone (reproductive hormone) level", type: "Blood" },
  { code: "84146", name: "Prolactin (milk producing hormone) level", type: "Blood" },
  { code: "84153", name: "PSA (prostate specific antigen) measurement, total", type: "Blood" },
  { code: "80061", name: "Lipid Panel Plus", type: "Blood" },
  { code: "87804", name: "Influenza Nasal Swab", type: "Nasal" },
  { code: "87807", name: "RSV Antigen Test", type: "Nasal" },
  { code: "87880", name: "Rapid Strep Test", type: "Throat" },
  { code: "87635", name: "Rapid COVID-19 Test", type: "Nasal" },
  { code: "84270", name: "Sex hormone binding globulin (protein) level", type: "Blood" },
  { code: "84403", name: "Testosterone (hormone) level, total", type: "Blood" },
  { code: "84436", name: "Thyroxine (thyroid chemical), total", type: "Blood" },
  { code: "84439", name: "Thyroxine (thyroid chemical), free", type: "Blood" },
  { code: "84443", name: "Thyroid stimulating hormone (TSH)", type: "Blood" },
  { code: "84480", name: "Thyroid hormone, T3 measurement, total", type: "Blood" },
  { code: "84481", name: "Thyroid hormone, T3 measurement, free", type: "Blood" },
  { code: "84484", name: "Troponin (protein) level", type: "Blood" },
  { code: "81003", name: "Urinalysis, Automated", type: "Urine" },
  { code: "87081", name: "Urine Culture", type: "Urine" },
  { code: "80305", name: "Urine Drug Screen", type: "Urine" },
  { code: "80310", name: "Urine Pregnancy Test", type: "Urine" },
  { code: "82565", name: "Glomerular Filtration Rate (GFR)", type: "Blood" },
  { code: "82306", name: "Vitamin D-3 level", type: "Blood" },
];

const labTypes = ["Blood", "EKG", "Urine", "Nasal", "Throat", "Stool", "Finger Stick"];

const RISOrderLabsModal = ({ isOpen, onClose, onOrderPlaced, followupNoteId, risPatientId }) => {
  const { currentUser } = useContext(GlobalStateContext);
  const BASE_URL = process.env.REACT_APP_API_URL;
  const user = getUserId(currentUser);

  const [sampleType, setSampleType] = useState('');
  const [examOrdered, setExamOrdered] = useState('');
  const [cptCode, setCptCode] = useState('');
  const [selectedLabIndex, setSelectedLabIndex] = useState('');
  const [notes, setNotes] = useState('');
  const [priority, setPriority] = useState('Routine');
  const [clinicalHistory, setClinicalHistory] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const resetForm = () => {
    setSampleType('');
    setCptCode('');
    setExamOrdered('');
    setSelectedLabIndex('');
    setNotes('');
    setPriority('Routine');
    setClinicalHistory('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!sampleType) { toast.warning('Please select a sample type'); return; }
    if (selectedLabIndex === '') { toast.warning('Please select a lab test'); return; }

    setIsSubmitting(true);
    try {
      const response = await fetch(`${BASE_URL}/orders/followUpLabOrder`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          followup_note_id: followupNoteId,
          ris_patients_id: risPatientId,
          cpt_code: cptCode,
          exam_ordered: examOrdered,
          specimen_type: sampleType,
          priority,
          clinical_history: clinicalHistory,
          notes,
          user,
          type: currentUser.type,
        }),
      });

      const data = await response.json();
      if (response.ok) {
        toast.success(data.msg || 'Lab order submitted successfully');
        resetForm();
        if (onOrderPlaced) await onOrderPlaced();
      } else {
        toast.error(data.msg || 'Failed to submit lab order');
      }
    } catch (error) {
      logger.error('Error submitting lab order:', error);
      toast.error('Error submitting lab order. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="encounterOrderModal-backdrop" onClick={onClose}>
      <div className="encounterOrderModal-modal" onClick={e => e.stopPropagation()}>
        <h2 className="encounterOrderModal-title">Order a Lab Test</h2>
        <button className="encounterOrderModal-close" onClick={onClose}>×</button>

        <div className="lab-container">
          <form onSubmit={handleSubmit}>
            <div className="field">
              <label className="label-field">Sample Type:</label>
              <select className="select-field" value={sampleType} onChange={e => setSampleType(e.target.value)} disabled={isSubmitting}>
                <option value="">Select Sample:</option>
                <option value="All">All</option>
                {labTypes.map(t => <option key={t} value={t}>{t}</option>)}
              </select>
            </div>

            <div className="field">
              <label className="label-field">CPT Code:</label>
              <select
                className="select-field"
                value={selectedLabIndex}
                onChange={e => {
                  const idx = Number(e.target.value);
                  const selected = labTests[idx];
                  if (selected) {
                    setSelectedLabIndex(e.target.value);
                    setCptCode(selected.code);
                    setExamOrdered(selected.name);
                  }
                }}
                disabled={!sampleType || isSubmitting}
              >
                <option value="">Select Lab Test</option>
                {labTests
                  .map((test, idx) => ({ test, idx }))
                  .filter(({ test }) => sampleType === 'All' || test.type === sampleType)
                  .map(({ test, idx }) => (
                    <option key={idx} value={idx}>{test.code ? `${test.code} - ${test.name}` : test.name}</option>
                  ))}
              </select>
            </div>

            <div className="field">
              <label className="label-field">Priority:</label>
              <select className="select-field" value={priority} onChange={e => setPriority(e.target.value)} disabled={isSubmitting}>
                <option value="Routine">Routine</option>
                <option value="STAT">STAT</option>
                <option value="Stroke">Stroke</option>
                <option value="Trauma">Trauma</option>
                <option value="Next Day">Next Day</option>
                <option value="2 Day">2 Day</option>
              </select>
            </div>

            <div className="field">
              <label className="label-field">Clinical History:</label>
              <textarea value={clinicalHistory} onChange={e => setClinicalHistory(e.target.value)} className="imaging-order-notes" rows={4} disabled={isSubmitting} />
            </div>

            <div className="field">
              <label className="label-field">Notes:</label>
              <input type="text" value={notes} onChange={e => setNotes(e.target.value)} className="imaging-order-notes" disabled={isSubmitting} />
            </div>

            <button type="submit" className="PrimaryButton" disabled={isSubmitting}>
              {isSubmitting ? 'Submitting...' : 'Submit Lab Order'}
            </button>
          </form>
        </div>

        <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      </div>
    </div>
  );
};

export default RISOrderLabsModal;
